import React from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import { logger } from '@ecosystem/newron-client-lib';

const ErrorFallback = ({ error }: FallbackProps) => {
  logger.error(error, {
    componentStack: error.stack,
  });

  return (
    <div className="newron-content">
      <div className="my-4">
        <feedbackV2.Alert
          title={
            <>
              The requested data for this page has failed to load.
              <br /> Please refresh your browser to try again. If this issue persists, please contact your GfK
              representative.
            </>
          }
          type="error"
        />
      </div>
    </div>
  );
};

interface LocalErrorBoundaryProps {
  children: React.ReactNode;
}

const LocalErrorBoundary: React.FC<LocalErrorBoundaryProps> = ({ children }) => {
  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
};

export default LocalErrorBoundary;
